import { Component, ViewChild, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreatePersonsCommand, GetEducatorSearchQuery } from 'src/shared/services/api.service';
import {
  CreateEducatorParams,
  EducatorSearchComponent,
} from '../educator-search-modal/educator-search-modal.component';
import { RouteType } from 'src/shared/constants';
import { RouteTypeService } from 'src/shared/services/route-type.service';

@Component({
  selector: 'cert-educator-modal',
  templateUrl: './educator-modal.component.html',
  styles: ``,
  standalone: false,
})
export class EducatorModalComponent implements OnInit {
  @ViewChild(EducatorSearchComponent) educatorSearchComponent!: EducatorSearchComponent;

  showEducatorSearch = signal(true);
  showEducatorCreateButton = signal(false);
  createPersonsCommand = signal<CreatePersonsCommand | undefined>(undefined);
  getEducatorSearchQuery = signal<GetEducatorSearchQuery>({ pageNumber: 1, pageSize: 10 });
  currentRouteType!: RouteType;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly routeTypeService: RouteTypeService,
  ) {}

  ngOnInit() {
    this.currentRouteType = this.routeTypeService.getRouteType();
  }

  toggleShowEducatorSearch(query: GetEducatorSearchQuery | null) {
    this.showEducatorSearch.set(!this.showEducatorSearch());
    if (query) {
      this.getEducatorSearchQuery.set(query);
    }
  }

  toggleEducatorCreateButton(createEducatorParams: CreateEducatorParams) {
    this.showEducatorCreateButton.set(true);

    this.createPersonsCommand.set({
      ssn: createEducatorParams.searchQuery.ssn ?? '',
      dateOfBirth: createEducatorParams.date,
      firstName: createEducatorParams.searchQuery.firstName ?? '',
      middleName: createEducatorParams.searchQuery.middleName,
      lastName: createEducatorParams.searchQuery.lastName ?? '',
      generateSSN: false,
      genderCodeId: undefined,
      ethnicityCodeId: undefined,
      raceCodeIds: [],
    });
  }

  close() {
    this.activeModal.close();
  }

  clearEducatorSearchForm() {
    this.educatorSearchComponent.clearFormInputs();
  }

  getEducatorSearchLabel(): string {
    return [RouteType.Lea2].some((x) => x === this.currentRouteType) ? 'Staff Search' : 'Educator Search';
  }
}
